module.exports = __webpack_public_path__ + "static/commit.ed3d2ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/git-github-presentation/commit.png
// module id = 1060
// module chunks = 32308089046778